(() => {
  document.addEventListener('click', function(e){
    if (e.target.matches('a.button')) {

      if (e.target.innerText.toLowerCase() === 'member registration') {
        window.gtag('event', 'conversion', {'send_to': 'AW-866805040/qCKhCOqzgfwBELDKqZ0D'});
      }

      if (e.target.innerText.toLowerCase() === 'non-member registration') {
        window.gtag('event', 'conversion', {'send_to': 'AW-866805040/Coz7CKDTlvwBELDKqZ0D'});
      }
    }
  });
})();